import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import { categoryData, categoryList } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const activeSlug = slug || 'movie';
  const data = categoryData[activeSlug as keyof typeof categoryData] || categoryData.movie;

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={`${data.name} - 糖心视频 | ${data.name}大全高清免费在线观看`}
        description={data.description}
        keywords={`${data.name}, 热门${data.name}, ${data.name}大全, 最新${data.name}, 高清${data.name}, 在线${data.name}, 糖心视频`}
        canonicalUrl={`https://www.tangxinsp.com/category/${activeSlug}`}
      />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { name: '首页', path: '/' },
                { name: data.name },
              ]}
            />
          </div>
        </div>

        <section className="w-full px-4 md:px-6 py-8 md:py-12 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              {data.name}
            </h1>
            <p className="text-foreground-500 text-sm md:text-base mb-8 max-w-2xl">
              {data.description}
            </p>

            <div className="flex items-center gap-2 flex-wrap mb-8">
              {categoryList.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-1 py-1 rounded-full transition-colors cursor-pointer`}
                >
                  <span
                    className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap ${
                      activeSlug === cat.slug
                        ? 'bg-primary-500 text-white'
                        : 'bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200/70'
                    }`}
                  >
                    <i className={`${cat.icon} text-base`}></i>
                    {cat.name}
                  </span>
                </Link>
              ))}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
              {data.items.map((item) => (
                <Link
                  key={item.id}
                  to={`/article/${item.id}`}
                  className="group cursor-pointer"
                >
                  <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                      <div className="flex items-center gap-1">
                        <i className="ri-star-fill text-accent-500 text-xs"></i>
                        <span className="text-white text-sm font-medium">{item.rating}</span>
                      </div>
                    </div>
                  </div>
                  <h3 className="font-medium text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-foreground-400">{item.year}</span>
                    <span className="text-xs text-foreground-300">|</span>
                    <span className="text-xs text-foreground-400">{item.genre}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}